"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Dialog", {
    enumerable: true,
    get: function() {
        return Dialog;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useDialog = require("./useDialog");
const _renderDialog = require("./renderDialog");
const _useDialogContextValues = require("./useDialogContextValues");
const Dialog = /*#__PURE__*/ _react.memo((props)=>{
    const state = (0, _useDialog.useDialog_unstable)(props);
    const contextValues = (0, _useDialogContextValues.useDialogContextValues_unstable)(state);
    return (0, _renderDialog.renderDialog_unstable)(state, contextValues);
});
Dialog.displayName = 'Dialog';
